import { render, staticRenderFns } from "./vedio-tips.vue?vue&type=template&id=ab73ada2&"
import script from "./vedio-tips.vue?vue&type=script&lang=js&"
export * from "./vedio-tips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports